// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2546":"861b7b69","5393":"1b7b6580","6619":"03fb0695","9687":"d1638c0c"}[chunkId] + ".chunk.css";
};